import { defineConfig } from './config.default'

export default defineConfig({
	environment: 'production',
	
	maintenance: {
		check_on_save: true,
		message: undefined
	},
})